import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description"]
  static values = { descriptions: Object }

  connect() {
    this.update()
  }

  update() {
    const id = this.selectTarget.value
    const text = this.descriptionsValue[id] || ""
    this.descriptionTarget.textContent = text
    this.descriptionTarget.classList.toggle("d-none", !text)
  }
}
